import { render, staticRenderFns } from "./ConfiguracaoOrcamento.vue?vue&type=template&id=18a70b30&lang=html&"
import script from "./ConfiguracaoOrcamento.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoOrcamento.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracaoOrcamento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/configuracao/ConfiguracaoOrcamento.vue
// module id = 1145
// module chunks = 28